/* componente para elegir el metodo de pago en los first drawer */
import React from 'react';
import { Tooltip, Typography, Box } from '@mui/material';
import logoMeLi from '../../../../../../../assets/logoMeLi.svg';
import logoPagotic from '../../../../../../../assets/logoPagotic.svg';
import logoPVS from '../../../../../../../assets/pvs-logo.jpg';
import logoClickMacro from '../../../../../../../assets/clickmacro-logo.jpg';
import { InfoOutlined } from '@mui/icons-material';

const PaymentMethodSelector = ({
  medioPago,
  setMedioPago,
  mediosPago,
  eventoId,
  mostrarBotonLink,
  mostrarBotonQR,
  isMobile = false,
  todasGratuitas = false,
  todasConAprobacion = false,
  hayAprobacion = false
}) => {

  // nota chica sobre las entradas que requieren aprobación (para carritos mixtos)
  const NotaAprobacion = () => (
    <Box sx={{
      width: "100%",
      padding: "12px 16px",
      marginBottom: "15px",
      backgroundColor: "#f0f0ff",
      borderRadius: "8px",
      border: "1px dashed #5656FF"
    }}>
      <Typography variant="body2" sx={{ color: "#5656FF" }}>
        Algunas entradas seleccionadas requieren la aprobación del organizador.
        Esas quedarán pendientes y te enviaremos los tickets por email cuando las apruebe.
      </Typography>
    </Box>
  );

  // caso: TODO lo seleccionado requiere aprobación del organizador
  if (todasConAprobacion) {
    return (
      <>
        <p style={{
          color: "#221A60",
          fontSize: "24px",
          marginBottom: "5px",
        }}>
          Solicitud de tickets
        </p>
        <Box sx={{
          width: "100%",
          textAlign: "center",
          padding: "20px",
          marginBottom: "15px",
          backgroundColor: "#f8f9fa",
          borderRadius: "8px",
          border: "1px dashed #5656FF"
        }}>
          <Typography variant="h6" sx={{ color: "#5656FF", mb: 1 }}>
            Requiere aprobación del organizador
          </Typography>
          <Typography variant="body2" sx={{ color: "#6c757d" }}>
            Estas entradas no se envían automáticamente. Al hacer clic en el botón, tu solicitud
            queda pendiente y, cuando el organizador la apruebe, te enviaremos los tickets por email.
          </Typography>
        </Box>
      </>
    );
  }

  if (todasGratuitas) {
    return (
      <>
        <p style={{
          color: "#221A60",
          fontSize: "24px",
          marginBottom: "5px",
        }}>
          Tickets gratuitos
        </p>
        <Box sx={{
          width: "100%",
          textAlign: "center",
          padding: "20px",
          marginBottom: "15px",
          backgroundColor: "#f8f9fa",
          borderRadius: "8px",
          border: "1px dashed #5656FF"
        }}>
          <Typography variant="h6" sx={{ color: "#5656FF", mb: 1 }}>
            ¡Excelente!
          </Typography>
          <Typography variant="body2" sx={{ color: "#6c757d" }}>
            Todos los tickets seleccionados son gratuitos.
            Haz clic en el botón para obtenerlos.
          </Typography>
        </Box>
        {hayAprobacion && <NotaAprobacion />}
      </>
    );
  }

  const es549 = String(eventoId) === "549";

  return (
    <>
      <p style={{ color: "#221A60", fontSize: "24px", marginBottom: "5px" }}>
        Pagar con
      </p>
      {hayAprobacion && <NotaAprobacion />}
      <div style={{ width: "100%", textAlign: "left" }}>
        {/* MercadoPago */}
        {mediosPago?.mercado_pago && eventoId !== "479" && eventoId !== "480" && (
          <>
            <PaymentOption
              id="mercadopago"
              value="mercadopago"
              checked={medioPago === 'mercadopago'}
              onChange={setMedioPago}
              label="Mercado Pago"
              logo={logoMeLi}
              isMobile={isMobile}
            />
            {/* {!isMobile && (
              <PaymentOption
                id="mercadopago-qr"
                value="mercadopago-qr"
                checked={medioPago === 'mercadopago-qr'}
                onChange={setMedioPago}
                label="Mercado Pago QR"
                logo={logoMeLi}
                isMobile={isMobile}
              />
            )} */}
          </>
        )}

        {/* PagoTIC */}
        {mediosPago?.pagotic && mostrarBotonLink('pagotic') && (
          <PaymentOption
            id="pagotic"
            value="pagotic"
            checked={medioPago === 'pagotic'}
            onChange={setMedioPago}
            label="PagoTIC"
            logo={logoPagotic}
            tooltip="PagoTIC es una plataforma segura que te permite pagar con tarjeta de crédito, débito o transferencia bancaria"
            isMobile={isMobile}
          />
        )}

        {/* PVS */}
        {mediosPago?.pvs && (
          <>
            {mostrarBotonLink('pvs') && (
              <PaymentOption
                id="pvs-link"
                value="pvs-link"
                checked={medioPago === 'pvs-link'}
                onChange={setMedioPago}
                label={es549 ? "Crédito en cuotas" : "PVS"}
                logo={logoPVS}
                tooltip="Paga a través de un link seguro con tu tarjeta o escanea un QR con tu billetera virtual"
                isMobile={isMobile}
              />
            )}
            {mostrarBotonQR('pvs') && (
              <PaymentOption
                id="pvs-qr"
                value="pvs-qr"
                checked={medioPago === 'pvs-qr'}
                onChange={setMedioPago}
                label={es549 ? "QR" : "PVS QR"}
                logo={logoPVS}
                tooltip="Paga escaneando el código QR con tu app de banco"
                isMobile={isMobile}
              />
            )}
          </>
        )}

        {/* Click Macro */}
        {mediosPago?.click_macro && (
          <>
            {mostrarBotonQR('clickmacro') && (
              <PaymentOption
                id="clickmacro-qr"
                value="clickmacro-qr"
                checked={medioPago === 'clickmacro-qr'}
                onChange={setMedioPago}
                label="Click Macro - QR"
                logo={logoClickMacro}
                isMobile={isMobile}
              />
            )}
            {mostrarBotonLink('clickmacro') && (
              <PaymentOption
                id="clickmacro-link"
                value="clickmacro-link"
                checked={medioPago === 'clickmacro-link'}
                onChange={setMedioPago}
                label="Click Macro"
                logo={logoClickMacro}
                isMobile={isMobile}
              />
            )}
          </>
        )}

        {!mediosPago?.mercado_pago && !mediosPago?.pagotic && !mediosPago?.pvs && !mediosPago?.click_macro && (
          <p className="text-center text-muted">
            No hay métodos de pago disponibles para este evento.
          </p>
        )}
      </div>
    </>
  );
};

const PaymentOption = ({ id, value, checked, onChange, label, logo, tooltip, isMobile = false }) => (
  <div
    className="d-flex justify-content-between align-items-center px-3 mb-2"
    style={{
      border: "1px solid #BDBDBD",
      borderRadius: "4px",
      backgroundColor: checked ? '#f5f5f5' : 'white',
    }}
  >
    <input
      type="radio"
      id={id}
      name="medioPago"
      value={value}
      checked={checked}
      onChange={(e) => onChange(e.target.value)}
    />
    <label htmlFor={id} className="mb-0 ml-3">{label}</label>
    {tooltip && (
      <Tooltip title={tooltip} placement="top" arrow>
        <InfoOutlined fontSize="small" style={{ color: '#6c757d', cursor: 'help', marginLeft: "10px" }} />
      </Tooltip>
    )}
    <img
      src={logo}
      alt={`Logo ${label}`}
      style={{
        padding: isMobile ? "5px 0" : "5px 0",
        width: isMobile ? "40px" : "50px",
        height: isMobile ? "45px" : "50px",
        borderRadius: logo === logoPVS ? "50%" : "0",
        marginLeft: "auto"
      }}
    />
  </div>
);

export default PaymentMethodSelector;